import { BuilderCreatableInterface } from '../interfaces/builder-creatable.interface';
import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { BuilderDto } from './builder.dto';

export class BuilderCreateDto
  extends IntersectionType(
    PickType(BuilderDto, ['code', 'name']),
    PartialType(PickType(BuilderDto, ['archived'])),
  )
  implements BuilderCreatableInterface {}
